import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import get from 'lodash/get'
import set from 'lodash/set'

import {
    updateTableColumnsConfig,
    updateTablePagination,
    updateTablePeriodDeltaDateRange,
    updateTablePeriodDeltaType,
    updateTablePeriodDeltaVisibility,
    updateTableRecord,
    updateTableTotalRowVisibility,
} from 'actions/ui/shared'

import { SharedState } from './state'

// Cases added to the shared/index createReducer; state is parent UI state
export const addTableCases = (
    builder: ActionReducerMapBuilder<SharedState>
): void => {
    builder
        // Columns Config
        .addCase(updateTableColumnsConfig, (state, action) => {
            const { path, columns } = action.payload
            set(state, [...path, 'tableSettings', 'columns'], columns)
        })

        // Pagination
        .addCase(updateTablePagination, (state, action) => {
            const { path, data: pagination } = action.payload
            const currentPagination = get(
                state,
                [...path, 'tableSettings', 'pagination'],
                {}
            )
            set(state, [...path, 'tableSettings', 'pagination'], {
                ...currentPagination,
                ...pagination,
            })
        })

        // Period Delta Visibility
        .addCase(updateTablePeriodDeltaVisibility, (state, action) => {
            const { path, data: isVisible } = action.payload
            set(
                state,
                [...path, 'tableSettings', 'showPeriodDeltas'],
                isVisible
            )
        })
        .addCase(updateTablePeriodDeltaType, (state, action) => {
            const { path, data: periodDeltaType } = action.payload
            set(
                state,
                [...path, 'tableSettings', 'periodDeltaType'],
                periodDeltaType
            )
        })
        .addCase(updateTableTotalRowVisibility, (state, action) => {
            const { path, data: isVisible } = action.payload
            set(state, [...path, 'tableSettings', 'showTotalRow'], isVisible)
        })
        .addCase(updateTablePeriodDeltaDateRange, (state, action) => {
            const { path, data: range } = action.payload
            set(
                state,
                [...path, 'tableSettings', 'periodDeltaDateRange'],
                range
            )
        })

        // Update Record
        .addCase(updateTableRecord, (state, action) => {
            const {
                path,
                data: { rowIndex, record },
            } = action.payload
            set(state, [...path, 'data', rowIndex], record)
        })
}
